<template>
  <div id="UpdateStatusNfe">
    <v-dialog v-model="open" persistent max-width="700">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <h1>Atualizar Status</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="mt10"></div>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="statusId"
                label="Novo Status"
                :items="status"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-col>
            <div v-if="shouldShowRemovedDelivererMessage" class="d-flex mx-3">
              <v-icon small class="mr-1"> mdi-information-outline </v-icon>
              <div>
                Atenção, a atualização por esse status irá
                <strong style="font-weight: 500"> desalocar </strong> entregadores alocados!
              </div>
            </div>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="justificationId"
                label="Justificativa"
                :items="getJustificationsById"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="observation" label="Observação"></v-textarea>
            </v-col>
          </v-row>

          <div class="mt10"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" large @click="close(false)"> Cancelar </v-btn>
          <v-btn
            color="success"
            class="flex-grow-1"
            large
            @click="sendNewStatusNfe()"
            :disabled="!checkForm()"
            :loading="isButtonLoading"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MessagesError :type="errorsType" :errors="errors" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MessagesError from '../MessagesError.vue';

export default {
  name: 'UpdateStatusNfe',
  components: { MessagesError },
  props: {
    open: {
      default: false,
      type: Boolean
    },
    selectedCheckbox: {
      default: () => [],
      type: Array
    },
    nfeSelected: {
      default: () => [],
      type: Array
    },
    types: {
      default: () => [],
      type: Array
    },
    role: {
      default: () => null,
      type: String
    }
  },
  data: () => ({
    isButtonLoading: false,
    errors: [],
    errorsType: 'error',
    error500: null,
    message: [],
    statusId: '',
    observation: '',
    justificationId: '',
    status: []
  }),
  watch: {
    open(val) {
      if (val === true) {
        this.fetchAll();
      }
    }
  },
  computed: {
    ...mapGetters('NfeStore', ['getStatus', 'getJustificationsById']),
    shouldShowRemovedDelivererMessage() {
      const inTransferStatusId = 12;
      const acceptedByTranshipmentStatusId = 3;
      return this.statusId === inTransferStatusId || this.statusId === acceptedByTranshipmentStatusId;
    }
  },
  methods: {
    ...mapActions('NfeStore', ['fetchStatus', 'fetchJustificationsById']),
    ...mapActions('ShipmentStore', ['changeStatus']),
    ...mapActions('QuarantineStore', ['moveDeliveryQuarantine', 'moveTransferQuarantine']),
    ...mapActions('GivBackStore', ['toBeReturned']),
    checkForm() {
      if (this.statusId === '' || this.observation === '' || this.justificationId === '') {
        return false;
      } else {
        return true;
      }
    },
    async sendNewStatusNfe() {
      this.isButtonLoading = true;
      let items = [];

      if (this.nfeSelected.length > 0) {
        items = this.nfeSelected;
      } else {
        items = this.selectedCheckbox;
      }

      const boardingIds = [];
      const cargoIds = [];
      const stopIds = [];
      const deliveryIds = [];
      const nfeIds = [];

      items.map((item) => {
        switch (item.type) {
          case 'Embarque':
            boardingIds.push(item.id);
            break;
          case 'Carga':
            cargoIds.push(item.id);
            break;
          case 'Parada':
            stopIds.push(item.id);
            break;
          case 'Entrega':
            deliveryIds.push(item.id);
            break;
          case 'Nota Fiscal':
            nfeIds.push(item.id);
            break;
        }
      });

      const params = {
        justificationChange: {
          justificationId: this.justificationId,
          observation: this.observation
        },
        boardingIds: boardingIds,
        cargoIds: cargoIds,
        stopIds: stopIds,
        deliveryIds: deliveryIds,
        nfeIds: nfeIds,
        newStatusId: this.statusId
      };

      try {
        let data = null;
        switch (this.role) {
          case 'Boardings':
            data = await this.changeStatus(params);
            break;
          case 'ToBeReturned':
            data = await this.toBeReturned(params);
            break;
          case 'DeliveryQuarantine':
            data = await this.moveDeliveryQuarantine(params);
            break;
          case 'TransferQuarantine':
            data = await this.moveTransferQuarantine(params);
            break;
        }

        if (data.success) {
          this.message = {
            errors: ['O Status foi atualizado com sucesso!'],
            errorsType: 'success'
          };
        } else {
          console.log(data);
          this.message = {
            errors: data.errors,
            errorsType: 'error',
            error500: data
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.close(true, this.message);
        this.isButtonLoading = false;
      }
    },
    fetchStatusItems() {
      var status = this.getStatus;
      status.map((element) => {
        return this.status.push(element);
      });
    },
    close(hasChange, message) {
      this.$emit('closeUpdateStatusNfe', hasChange, message);
      this.statusId = '';
      this.observation = '';
      this.justificationId = '';
    },
    async fetchAll() {
      try {
        await this.fetchStatus(this.role);
        this.fetchStatusItems();

        try {
          switch (this.role) {
            case 'Boardings':
              await this.fetchJustificationsById(2);
              break;
            case 'ToBeReturned':
              await this.fetchJustificationsById(6);
              break;
            case 'DeliveryQuarantine':
              await this.fetchJustificationsById(4);
              break;
            case 'TransferQuarantine':
              await this.fetchJustificationsById(5);
              break;
          }
        } catch (e) {
          console.error(e);
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#UpdateStatusNfe {
}
</style>
